import React, {FC, useEffect} from 'react';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import {useTranslation} from "react-i18next";
import { DeliveryService } from '../../api/DeliveryService';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { autofillDeliveryReturn, setReturnDate } from '../../stateReducers/deliverySlice';

interface ReturnDatePickerInterface {
    deliveryService: DeliveryService
}

const ReturnDatePicker: FC<ReturnDatePickerInterface> = ({
                                                             deliveryService
                                                         }) => {
    const {t} = useTranslation();
    const formType = useAppSelector((state) => { return state.delivery.formType; });
    const minReturnDate = useAppSelector((state) => { return state.delivery.minReturnDate; });
    const maxReturnDate = useAppSelector((state) => { return state.delivery.maxReturnDate; });
    const returnDate = useAppSelector((state) => { return state.delivery.returnDate; });
    const d = useAppDispatch();

    useEffect(() => {
        if (!returnDate) {
            d(autofillDeliveryReturn({}));
        }
    }, []);
    if (formType === 'YouthPromo') {
        // For the YouthPromo, the date is chosen automatically.
        if (!minReturnDate) {
            return (
                <div>
                    <p>
                        {t('chooseNewPlayDate')}
                    </p>
                </div>
            );
        } else {
            let dateString = format(minReturnDate,"yyy-MM-dd");
            return (
                <div>
                    <p>
                        {dateString}
                    </p>
                </div>
            );
        }
    } else {
        return (
            <DatePicker
                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-200 focus:shadow-none focus:outline-none focus:outline-none"
                onChange={(date) => d(setReturnDate(date))}
                selected={returnDate}
                filterDate={DeliveryService.isWorkingDate}
                placeholderText={t('delivery.selectReturnDatePlaceholder')}
                minDate={minReturnDate}
                maxDate={maxReturnDate}
                calendarStartDay={1}
                withPortal
                portalId="modal-root"
                dateFormat="dd-MM-yyyy"
            />
        );
    }
};

export default ReturnDatePicker;
